import { ChangeDetectionStrategy, Component, Input, OnInit } from "@angular/core";
import { IGoalNode } from "@gtmhub/goals/models";
import { ISessionsStoreState } from "@gtmhub/sessions/redux/session-reducer";
import { reduxStoreContainer } from "@gtmhub/state-management/state-management.module";
import { IPlanningSessionsIdMap } from "@webapp/sessions/models/sessions.model";
import { GoalTreeService } from "./goal-tree.service";

@Component({
  selector: "single-goal-selector-goal-tree",
  templateUrl: "./goal-tree.component.html",
  styleUrls: ["./goal-tree.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SingleGoalSelectorGoalTreeComponent implements OnInit {
  @Input() public goalNode: IGoalNode;
  @Input() public unselectableId: string;
  @Input() public hidePrivate: boolean;

  public sessionsMap: IPlanningSessionsIdMap;

  constructor(private goalTreeService: GoalTreeService) {}

  public ngOnInit(): void {
    this.getSessions();
  }

  private getSessions(): void {
    this.sessionsMap = reduxStoreContainer.reduxStore.getState<ISessionsStoreState>().sessions.map;
  }

  public goalSelected(goalNode: IGoalNode): void {
    this.goalTreeService.setSelectedGoal(goalNode);
  }
}
